import { FileText } from "lucide-react";
import { CollapsibleCard } from "../CollapsibleCard";

interface EngineeringDocumentsSectionProps {
  submission: any;
  defaultOpen?: boolean;
}

export const EngineeringDocumentsSection = ({
  submission,
  defaultOpen = false,
}: EngineeringDocumentsSectionProps) => {
  return (
    <CollapsibleCard
      title="7. Engineering & Documents"
      defaultOpen={defaultOpen}
    >
      <div className="space-y-3 md:space-y-4">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Contractor Company
            </span>
            <span className="text-sm font-medium">
              {submission.contractorCompany}
            </span>
          </div>
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Contractor License
            </span>
            <span className="text-sm font-medium">
              {submission.contractorLicenseNo}
            </span>
          </div>
          <div className="flex flex-col gap-1 md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Contractor Address
            </span>
            <span className="text-sm font-medium">
              {submission.contractorAddress}
            </span>
          </div>
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Contractor Phone
            </span>
            <span className="text-sm font-medium">
              {submission.contractorPhone}
            </span>
          </div>
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              PE Stamp Required
            </span>
            <span className="text-sm font-medium">
              {submission.peStampRequired?.replace(/-/g, " ") || "—"}
            </span>
          </div>

          {/* Documents */}
          <div className="space-y-2 pt-3 border-t md:border-t-0 md:pt-0 md:col-span-2">
            <span className="text-sm font-medium text-muted-foreground">
              Documents
            </span>
            <div className="flex flex-col gap-2 md:flex-row md:flex-wrap md:gap-4">
              {submission.files?.cadFile && (
                <a
                  href={submission.files.cadFile.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-sm font-medium text-primary hover:underline"
                >
                  <FileText className="mr-2 h-4 w-4" /> CAD File
                </a>
              )}
              {submission.files?.projectValuationDocs && (
                <a
                  href={submission.files.projectValuationDocs.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-sm font-medium text-primary hover:underline"
                >
                  <FileText className="mr-2 h-4 w-4" /> Valuation Docs
                </a>
              )}
              {submission.files?.bom && (
                <a
                  href={submission.files.bom.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-sm font-medium text-primary hover:underline"
                >
                  <FileText className="mr-2 h-4 w-4" /> BOM Document
                </a>
              )}
              {submission.files?.contractorLicense && (
                <a
                  href={submission.files.contractorLicense.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-sm font-medium text-primary hover:underline"
                >
                  <FileText className="mr-2 h-4 w-4" /> Contractor License
                </a>
              )}
              {submission.files?.architecturalFile &&
                submission.files.architecturalFile.length > 0 && (
                  <div className="space-y-1 w-full">
                    <span className="text-sm font-medium text-muted-foreground block mb-1">
                      Architectural Files
                    </span>
                    <div className="flex flex-col gap-2 md:flex-row md:flex-wrap md:gap-4">
                      {submission.files.architecturalFile.map(
                        (file: any, index: number) => (
                          <a
                            key={index}
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center text-sm font-medium text-primary hover:underline"
                          >
                            <FileText className="mr-2 h-4 w-4" />
                            {file.name}
                          </a>
                        )
                      )}
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </CollapsibleCard>
  );
};
